﻿import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../../style/style.css";
import logo from "../../assets/logo.png";
import backgroundImg from "../../assets/background_novo.png";
import axios from 'axios';
import { Modal } from "react-bootstrap";
import Search from "@mui/icons-material/Search.js";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { uploadFileToS3, S3_BUCKETS } from '../../services/s3Service';

const Login = () => {
  const [email, setEmail] = useState('assist.financeiro@transtecworld.com');
  const [passwordAPI, setPasswordAPI] = useState('Tec1906@');
  const [cpf_user, setCpf_user] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const parsedURL = localStorage.getItem('urlParsed');
  const nodeURL = localStorage.getItem('urlNodeOp');
  const [modalOpen, setModalOpen] = useState(false)
  const [cnpjValido, setCnpjValido] = useState(false);
  // Novo estado para controlar o loading da validação do CNPJ
  const [isValidatingCNPJ, setIsValidatingCNPJ] = useState(false);
  const [formState, setFormState] = useState({
    senha: "",
    email: "",
    cnpj: "",
    confirm: "",
    isPasswordMatch: "",
  });
  
  // Estados para controle de etapas do modal
  const [currentStep, setCurrentStep] = useState(1);
  
  // Estados para gerenciamento de contatos
  const [contatosList, setContatosList] = useState([]);
  const [contatoFormFinanceiro, setContatoFormFinanceiro] = useState({
    nome: "",
    telefone: "",
    email: ""
  });
  const [contatoFormOperacional, setContatoFormOperacional] = useState({
    nome: "",
    telefone: "",
    email: ""
  });
  const [contatoFormAdministrativo, setContatoFormAdministrativo] = useState({
    nome: "",
    telefone: "",
    email: ""
  });
  const [editingContatoIndex, setEditingContatoIndex] = useState(null);
  const [dataApiBrasil, setDataApiBrasil] = useState();
  const [formulario, setFormulario] = useState({
    fantasia: '',
    razao_social: '',
    logradouro: '',
    cep: '',
    estado: '',
    cidade: '',
    numero: '',
  });
  const [modalFormulario, setModalFormulario] = useState(false);
  const [isSubmittingEntity, setIsSubmittingEntity] = useState(false);

  // Estados para modal de usuário pendente com email pessoal
  const [modalPendente, setModalPendente] = useState(false);
  const [pendingUserData, setPendingUserData] = useState(null);
  const [declaracaoPendenteFile, setDeclaracaoPendenteFile] = useState(null);
  const [declaracaoPendenteS3Key, setDeclaracaoPendenteS3Key] = useState('');
  const [isUploadingDeclaracaoPendente, setIsUploadingDeclaracaoPendente] = useState(false);
  const [isSubmittingDeclaracaoPendente, setIsSubmittingDeclaracaoPendente] = useState(false);

  // Estados para modal de recuperação de senha
  const [modalRecuperarSenha, setModalRecuperarSenha] = useState(false);
  const [recuperarCpf, setRecuperarCpf] = useState('');
  const [isRecuperandoSenha, setIsRecuperandoSenha] = useState(false);

  // Estados para toggle de senha e banner de cookies
  const [showPassword, setShowPassword] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    handleLoginApiBrasil();
  }, []);

  useEffect(() => {
    const cookieAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookieAccepted) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowBanner(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Funções para recuperação de senha
  const handleOpenRecuperarSenha = () => {
    setModalRecuperarSenha(true);
  };

  const handleCloseRecuperarSenha = () => {
    setModalRecuperarSenha(false);
    setRecuperarCpf('');
  };

  const handleRecuperarSenha = async () => {
    setIsRecuperandoSenha(true);
    try {
      const cpfLimpo = recuperarCpf.replace(/\D/g, '');
      await axios.post(
        `${nodeURL}cadastro/recuperar-senha`,
        { cpf: cpfLimpo },
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }
      );
    } catch (error) {
      // Silencia o erro para não revelar se o CPF existe ou não
    } finally {
      toast.success('Se o CPF estiver cadastrado, um e-mail de recuperação será enviado.');
      setIsRecuperandoSenha(false);
      handleCloseRecuperarSenha();
    }
  };

  const handleLoginApiBrasil = async () => {
    try {
      const res = await axios.post('https://gateway.apibrasil.io/api/v2/login', {
        email: email,
        password: passwordAPI
      }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      setDataApiBrasil(res.data);
      //setError(null);
    } catch (err) {
      //setResponse(null);
    }
  };

  const handleGetCNPJ = async () => {
    try {
      const response = await axios.post(`https://cluster.apigratis.com/api/v2/dados/cnpj`,
        {
          "tipo": "cnpj",
          "cnpj": formState.cnpj,
          "homolog": false
        },
        {
          headers: {
            'accept': 'application/json',
            'DeviceToken': process.env.REACT_APP_DEVICE_AUTH_TOKEN_CNPJ,
            'Authorization': `Bearer ${dataApiBrasil.authorization.token}`
          },
        }
      );
      if (response.data.error === false) {
        const cnpjResponse = response.data.response.cnpj;
        setFormulario(prevState => ({
          ...prevState,
          fantasia: cnpjResponse.nome_fantasia || '',
          razao_social: cnpjResponse.empresa.razao_social || '',
          logradouro: (cnpjResponse.tipo_logradouro || '') + ' ' + (cnpjResponse.logradouro || '') + ', ' + (cnpjResponse.bairro || '') + ', ' + (cnpjResponse.complemento || ''),
          cep: cnpjResponse.cep || '',
          estado: cnpjResponse.uf || '',
          cidade: (cnpjResponse.municipio && cnpjResponse.municipio.descricao) || '',
          numero: cnpjResponse.numero || ''
        }));
        return true; // CNPJ validado com sucesso
        //resolve("CNPJ validado com sucesso!");
      }
      else {
        return false;
        //reject(new Error('Erro na resposta da API, verifique os dados e tente novamente.'));
      }
    } catch (error) {
      if (error.request.status === 404) {
        return false; // CNPJ Não encontrado
      }
    }
  }

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      };
      const resposta = await axios.post(
        `${parsedURL}post/login`,
        {
          cpf: cpf_user,
          password: password
        },
        { headers }
      );
      
      // Status 201 - Login bem-sucedido
      if (resposta.status === 201) {
        const data = resposta.data.user;
        const token = resposta.data.token;
        
        if (data.active === 'S' && data.verify === 1) {
          const currentTime = Date.now()
          localStorage.setItem('token', token);
          localStorage.setItem('typeUser', data.id_tipo_usuario);
          localStorage.setItem('idUser', data.id_usuario);
          localStorage.setItem('userName', data.nome);
          localStorage.setItem('idEnt', data.id_entidade);
          localStorage.setItem('codArea', data.codArea);
          localStorage.setItem('policy', data.policy);
          localStorage.setItem('policyData', data.policy_date);
          setLoading(false);
          localStorage.setItem('user_login_time', currentTime.toString());
          window.location.href = `${window.location.origin}/home`
        } 
        else if (data.verify === 0) {
          toast.error('Ativação de conta pendente. Verifique seu email!');
        }
        else if (data.active === 'N') {
          toast.error('Usuario Inativo! Entre em contato com o administrador.');
        }
        else if (data.active === 'P') {
          toast.warning('Aguardando aprovação do cadastro. Por favor, aguarde.');
        }
        setLoading(false);
      }
      // Status 202 - Usuário inativo
      else if (resposta.status === 202) {
        toast.error('Usuario Inativo! Entre em contato com o administrador.');
      }
      else if (resposta.status === 203) {
        const userData = resposta.data.user;
        if (userData?.email) {
          const domain = userData.email.split('@')[1]?.toLowerCase();
          if (domain && freeEmailDomains.includes(domain)) {
            setPendingUserData(userData);
            setModalPendente(true);
          } else {
            toast.warning('Aprovação pendente. Por favor, aguarde.');
          }
        } else {
          toast.warning('Aprovação pendente. Por favor, aguarde.');
        }
      }
      // Outros status codes de sucesso inesperados
      else {
        toast.error('Erro inesperado. Tente novamente.');
      }
      
    } catch (error) {
      
      // Tratar diferentes status codes de erro (4xx, 5xx)
      if (error.response?.status === 404) {
        toast.error('Usuario ou senha incorreto!');
      } else {
        toast.error('Usuario ou senha incorreto!');
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleLogin(event);
    }
  };

  const handleModal = () => {
    setModalOpen(true);
  }

  const handleCloseModal = () => {
    setModalOpen(false);
    // Resetar para etapa 1 quando fechar o modal
    setCurrentStep(1);
    setContatosList([]);
    setContatoFormFinanceiro({
      nome: "",
      telefone: "",
      email: ""
    });
    setContatoFormOperacional({
      nome: "",
      telefone: "",
      email: ""
    });
    setContatoFormAdministrativo({
      nome: "",
      telefone: "",
      email: ""
    });
    setEditingContatoIndex(null);
    setDeclaracaoFile(null);
    setDeclaracaoS3Key('');
    setIsEmailPessoal(false);
  }

  const handleSendUser = (event) => {
    event.preventDefault();
    
    // Se estiver na primeira etapa, avançar para a segunda
    if (currentStep === 1) {
      setCurrentStep(2);
      return;
    }
    
    // Segunda etapa: enviar usuário e contatos
    // Bloquear envio se email pessoal sem declaração anexada
    if (isEmailPessoal && !declaracaoS3Key) {
      toast.error('Para prosseguir com e-mail pessoal, é obrigatório anexar a declaração assinada.');
      return;
    }

    var cnpjreplace = formState.cnpj.replace(/[^A-Z0-9]/g, '')
    var cpfreplace = formState.cpf.replace(/[^A-Z0-9]/g, '')
    try {
      axios
        .post(`${parsedURL}post/cadastro/usuario2`, {
          ...formState,
          cnpj: cnpjreplace,
          cpf: cpfreplace,
          ...(declaracaoS3Key ? { path_declaracao: declaracaoS3Key } : {}),
        }, {})
        .then(async (response) => {
          
          // Capturar id_usuario retornado
          const idUsuario = response.data.id_usuario || response.data.id;
          
          // Enviar contatos se houver
          if (contatosList.length > 0 && idUsuario) {
            try {
              // Enviar cada contato
              for (const contato of contatosList) {
                const contatoData = {
                  nome: contato.nome,
                  telefone: contato.telefone,
                  email: contato.email,
                  tipo_contato: parseInt(contato.tipo_contato),
                  id_entidade: parseInt(formState.id_entidade)
                };
                
                await axios.post(
                  `${parsedURL}post/contato_no_auth/${formState.id_entidade}`,
                  contatoData,
                  {
                    headers: {
                      'accept': 'application/json',
                      'Content-Type': 'application/json'
                    }
                  }
                );
              }
            } catch (contatoError) {
              toast.warning('Usuário cadastrado, mas houve erro ao cadastrar alguns contatos.');
            }
          }
          
          setFormState({
            senha: '',
            confirm: '',
            email: '',
            cnpj: '',
            isPasswordMatch: '',
          });
          toast.success('Solicitação enviada com sucesso! Aguarde a validação do administrador.');
          handleCloseModal();
        })
        .catch((error) => {
          // Tratar erro de CPF duplicado
          if (error.response?.status === 409) {
            toast.error('CPF já cadastrado no sistema. Caso tenha esquecido sua senha, entre em contato com suporte@transtecworld.com.');
          } else {
            toast.error('Ocorreu um erro ao enviar o formulário. Por favor, tente novamente.');
          }
        });
    } catch (error) {
      // Tratar erro de CPF duplicado no try-catch externo
      if (error.response?.status === 409) {
        toast.error('CPF já cadastrado no sistema. Caso tenha esquecido sua senha, entre em contato com suporte@transtecworld.com.');
      } else {
        toast.error('Ocorreu um erro ao enviar o formulário. Por favor, tente novamente.');
      }
    }
  };

  // Funções para gerenciar contatos
  const handleContatoChange = (event, tipo_contato) => {
    const { name, value } = event.target;
    const formattedValue = name === "telefone" ? formatTelefone(value) : value;
    
    if (tipo_contato === 1) {
      setContatoFormFinanceiro(prevState => ({
        ...prevState,
        [name]: formattedValue
      }));
    } else if (tipo_contato === 2) {
      setContatoFormOperacional(prevState => ({
        ...prevState,
        [name]: formattedValue
      }));
    } else if (tipo_contato === 3) {
      setContatoFormAdministrativo(prevState => ({
        ...prevState,
        [name]: formattedValue
      }));
    }
  };

  const handleAddContato = (tipo_contato) => {
    let contatoForm;
    
    if (tipo_contato === 1) {
      contatoForm = contatoFormFinanceiro;
    } else if (tipo_contato === 2) {
      contatoForm = contatoFormOperacional;
    } else {
      contatoForm = contatoFormAdministrativo;
    }
    
    if (editingContatoIndex !== null) {
      // Editar contato existente
      const updatedContatos = [...contatosList];
      updatedContatos[editingContatoIndex] = {
        ...contatoForm,
        tipo_contato: tipo_contato
      };
      setContatosList(updatedContatos);
      setEditingContatoIndex(null);
      toast.success('Contato atualizado!');
    } else {
      // Adicionar novo contato com tipo específico
      const novoContato = {
        ...contatoForm,
        tipo_contato: tipo_contato
      };
      setContatosList([...contatosList, novoContato]);
      toast.success('Contato adicionado!');
    }

    // Resetar formulário específico
    if (tipo_contato === 1) {
      setContatoFormFinanceiro({ nome: "", telefone: "", email: "" });
    } else if (tipo_contato === 2) {
      setContatoFormOperacional({ nome: "", telefone: "", email: "" });
    } else {
      setContatoFormAdministrativo({ nome: "", telefone: "", email: "" });
    }
  };

  const getContatosPorTipo = (tipo) => {
    return contatosList.filter(c => parseInt(c.tipo_contato) === tipo);
  };

  const hasContatoDeTodasCategorias = () => {
    const hasFinanceiro = contatosList.some(c => parseInt(c.tipo_contato) === 1);
    const hasOperacional = contatosList.some(c => parseInt(c.tipo_contato) === 2);
    const hasAdministrativo = contatosList.some(c => parseInt(c.tipo_contato) === 3);
    return hasFinanceiro && hasOperacional && hasAdministrativo;
  };

  const handleDeleteContato = (index) => {
    const updatedContatos = contatosList.filter((_, i) => i !== index);
    setContatosList(updatedContatos);
    toast.success('Contato removido!');
  };

  const handleBackToStep1 = () => {
    setCurrentStep(1);
  };

  const getTipoContatoLabel = (tipo) => {
    switch (parseInt(tipo)) {
      case 1: return 'Financeiro';
      case 2: return 'Operacional';
      case 3: return 'Administrativo';
      default: return 'Contato';
    }
  };

  const getTipoContatoBadgeClass = (tipo) => {
    switch (parseInt(tipo)) {
      case 1: return 'bg-success';
      case 2: return 'bg-primary';
      case 3: return 'bg-warning';
      default: return 'bg-secondary';
    }
  };

  const formatTelefone = (tel) => {
    tel = tel.replace(/\D/g, "");
    if (tel.length <= 10) {
      return tel.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    } else {
      return tel.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }
  };

  // Lista de domínios de e-mail gratuitos/pessoais
  const freeEmailDomains = ['gmail.com', 'hotmail.com', 'outlook.com', 'yahoo.com', 'yahoo.com.br', 'live.com', 
    'msn.com', 'aol.com', 'icloud.com', 'me.com', 'mail.com', 'protonmail.com', 'proton.me', 'uol.com.br', 'bol.com.br',
    'terra.com.br', 'ig.com.br', 'globo.com', 'zipmail.com.br'];
  const [isEmailPessoal, setIsEmailPessoal] = useState(false);
  // Estados para declaração de email particular
  const [declaracaoFile, setDeclaracaoFile] = useState(null);
  const [declaracaoS3Key, setDeclaracaoS3Key] = useState('');
  const [isUploadingDeclaracao, setIsUploadingDeclaracao] = useState(false);

  const checkEmailCorporativo = (email) => {
    const domain = email.split('@')[1]?.toLowerCase();
    if (domain && freeEmailDomains.includes(domain)) {
      setIsEmailPessoal(true);
    } else {
      setIsEmailPessoal(false);
      // Limpar declaração se mudar para email corporativo
      setDeclaracaoFile(null);
      setDeclaracaoS3Key('');
    }
  };

  // Upload da declaração de email particular para S3
  const handleDeclaracaoUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      toast.error('Formato não aceito. Envie PDF, JPG ou PNG.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Arquivo muito grande. Máximo 5MB.');
      return;
    }

    setIsUploadingDeclaracao(true);
    try {
      const identifier = String(formState.id_entidade);
      const result = await uploadFileToS3(file, S3_BUCKETS.declaracaoEmail, identifier, true);
      if (result.success) {
        setDeclaracaoFile(file);
        setDeclaracaoS3Key(result.key);
        toast.success('Declaração enviada com sucesso!');
      } else {
        toast.error('Erro ao enviar declaração. Tente novamente.');
      }
    } catch (error) {
      toast.error('Erro ao enviar declaração. Tente novamente.');
    } finally {
      setIsUploadingDeclaracao(false);
    }
  };

  const handleRemoveDeclaracao = () => {
    setDeclaracaoFile(null);
    setDeclaracaoS3Key('');
  };

  // Handlers do modal de pendente com email pessoal
  const handleClosePendenteModal = () => {
    setModalPendente(false);
    setPendingUserData(null);
    setDeclaracaoPendenteFile(null);
    setDeclaracaoPendenteS3Key('');
  };

  const handleDeclaracaoPendenteUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      toast.error('Formato não aceito. Envie PDF, JPG ou PNG.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Arquivo muito grande. Máximo 5MB.');
      return;
    }

    setIsUploadingDeclaracaoPendente(true);
    try {
      const identifier = String(pendingUserData.id_entidade);
      const result = await uploadFileToS3(file, S3_BUCKETS.declaracaoEmail, identifier, true);
      if (result.success) {
        setDeclaracaoPendenteFile(file);
        setDeclaracaoPendenteS3Key(result.key);
        toast.success('Declaração enviada com sucesso!');
      } else {
        toast.error('Erro ao enviar declaração. Tente novamente.');
      }
    } catch (error) {
      toast.error('Erro ao enviar declaração. Tente novamente.');
    } finally {
      setIsUploadingDeclaracaoPendente(false);
    }
  };

  const handleSubmitDeclaracaoPendente = async () => {
    if (!declaracaoPendenteS3Key) {
      toast.error('Anexe a declaração assinada antes de enviar.');
      return;
    }
    setIsSubmittingDeclaracaoPendente(true);
    try {
      await axios.post(`${parsedURL}post/cadastro/declaracao_email_pendente`, {
        id_usuario: pendingUserData.id_usuario,
        id_entidade: pendingUserData.id_entidade,
        path: declaracaoPendenteS3Key
      });
      toast.success('Declaração enviada com sucesso! Aguarde a aprovação do administrador.');
      handleClosePendenteModal();
    } catch (error) {
      toast.error('Erro ao registrar declaração. Tente novamente.');
    } finally {
      setIsSubmittingDeclaracaoPendente(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "cpf") {
      const formattedValue = formatCPF(value);
      setFormState(prevState => ({
        ...prevState,
        [name]: formattedValue
      }));
    } else if (name === "cnpj") {
      const formattedValue = formatCNPJ(value);
      setFormState(prevState => ({
        ...prevState,
        [name]: formattedValue
      }));
    } else if (name === "nome") {
      setFormState(prevState => ({
        ...prevState,
        [name]: value.toUpperCase()
      }));
    } else if (name === "email") {
      checkEmailCorporativo(value);
      setFormState(prevState => ({
        ...prevState,
        [name]: value
      }));
    } else {
      setFormState(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const formatCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, "");
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };
  const formatCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/\D/g, "");
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  };
  const formatCEP = (cep) => {
    cep = cep.replace(/\D/g, "");
    return cep.replace(/(\d{5})(\d{3})/, "$1-$2");
  };

  const handleConfirmPassword = (event) => {
    const { value } = event.target;
    const { senha } = formState;

    if (value !== senha) {
      setFormState((prevState) => ({
        ...prevState,
        confirm: value,
        isPasswordMatch: false,
      }));
    } else {
      setFormState((prevState) => ({
        ...prevState,
        confirm: value,
        isPasswordMatch: true,
      }));
    }
  };

  const validateCNPJ = async () => {
    const { cnpj } = formState;
    const cnpjreplace = cnpj.replace(/[^A-Z0-9]/g, '');

    setIsValidatingCNPJ(true); // Ativar loading

    try {
      // Primeira validação: verificar se CNPJ já existe na base
      const response = await axios.get(`${parsedURL}get/tabelas/cnpj?cnpj=${cnpjreplace}`, {});

      if (response.status === 200) {
        setFormState((prevState) => ({
          ...prevState,
          id_entidade: response.data,
        }));
        setCnpjValido(true);
        toast.success('CNPJ validado com sucesso!');
        setIsValidatingCNPJ(false); // Desativar loading
        return;
      }
    } catch (error) {
    }

    try {
      // Segunda validação: tentar buscar dados na API externa
      const dados = await handleGetCNPJ();

      if (dados) {
        setCnpjValido(true);
        toast.success('CNPJ encontrado! Dados preenchidos automaticamente.');
        setModalFormulario(true); // Abrir modal para cadastrar entidade
      } else {
        setModalFormulario(true);
        toast.error('CNPJ Não encontrado nas APIs. Preencha o formulario de cadastro.');
      }
    } catch (error) {
      toast.error('Erro ao validar CNPJ. Verifique o número e tente novamente.');
    } finally {
      setIsValidatingCNPJ(false); // Desativar loading sempre no final
    }
  };

  const handleFormularioChange = (event) => {
    const { name, value } = event.target;
    if (name === "cep") {
      const formattedValue = formatCEP(value);
      setFormulario(prevState => ({
        ...prevState,
        [name]: formattedValue
      }));
    } else {
      setFormulario(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmitEntity = async (event) => {
    event.preventDefault();
    setIsSubmittingEntity(true);

    try {
      const cnpjreplace = formState.cnpj.replace(/[^A-Z0-9]/g, '');

      const entityData = {
        ...formulario,
        cnpj_cpf: cnpjreplace,
        A: 0,
        C: 0,
        T: 1,
        M: 0,
        V: 0,
        doc_type: 1,
        inscricao_estadual: '',
        cnh: '',
        obs: '',
        telefone_financeiro: '',
      };
      const response = await axios.post(
        `${parsedURL}post/cadastro/entidade2`,
        entityData,
        {
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success('Entidade cadastrada com sucesso!');
        setModalFormulario(false);
        setCnpjValido(true);

        // Resetar formulário
        setFormulario({
          fantasia: '',
          razao_social: '',
          logradouro: '',
          cep: '',
          estado: '',
          cidade: '',
          numero: '',
        });

        // Definir ID da entidade recém-criada
        setFormState(prevState => ({
          ...prevState,
          id_entidade: response.data.id_ent,
        }));
      }
    } catch (error) {
      toast.error('Erro ao cadastrar entidade. Tente novamente.');
    } finally {
      setIsSubmittingEntity(false);
    }
  };

  const handleCloseFormularioModal = () => {
    setModalFormulario(false);
    setFormulario({
      fantasia: '',
      razao_social: '',
      logradouro: '',
      cep: '',
      estado: '',
      cidade: '',
      numero: '',
    });
  };

  // Verificar se todos os campos obrigatórios estão preenchidos
  const isFormularioCompleto = () => {
    const { razao_social, logradouro, cep, cidade, estado, numero } = formulario;
    return razao_social.trim() !== '' &&
      logradouro.trim() !== '' &&
      cep.trim() !== '' &&
      cidade.trim() !== '' &&
      estado.trim() !== '' &&
      numero.trim() !== '';
  };

  return (
    <>
      <body className="my-login-page">
        <section className="min-vh-100 d-flex flex-column position-relative" style={{ overflow: 'hidden' }}>
          <div style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url(${backgroundImg})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            opacity: 0.5,
            zIndex: 0
          }} />
          <div style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(135deg, #1e3c72 0%, #ffffff 50%, #1a237e 100%)',
            opacity: 0.85,
            zIndex: 1
          }} />
          <div className="container-fluid flex-grow-1 d-flex align-items-center justify-content-center py-5 position-relative" style={{ zIndex: 2 }}>
            <div className="row w-100 align-items-center justify-content-center">

              {/* Coluna central - Login */}
              <div className="col-lg-4 col-md-6 col-sm-8 d-flex justify-content-center">
                <div className="card-wrapper w-100" style={{ maxWidth: '450px' }}>
                  <div className="card shadow-lg border-0" style={{
                    borderRadius: '20px',
                    overflow: 'hidden',
                    background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)'
                  }}>

                    {/* Header do card com logo */}
                    <div className="card-header text-white text-center py-4 header-main" style={{
                      background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #1a237e 100%)'
                    }}>
                      <Link to='https://transtecworld.com/' className="text-decoration-none">
                        <img src={logo} alt="Logo Transtec" style={{ maxHeight: '80px' }} className="img-fluid" />
                      </Link>
                      <h4 className="mt-3 mb-0 fw-bold">Sistema de Agendamento</h4>
                    </div>

                    <div className="card-body p-5">
                      <h5 className="card-title text-center mb-4 fw-bold" style={{
                        color: '#1e3c72',
                        fontSize: '1.8rem'
                      }}>
                        <i className="bi bi-person-circle me-2"></i>
                        Acesso ao Sistema
                      </h5>

                      <form onSubmit={handleLogin}>
                        <div className="form-floating mb-4">
                          <input
                            type="text"
                            className="form-control form-control-lg shadow-sm"
                            id="floatingInput"
                            placeholder="111.111.111-11"
                            onChange={(e) => {
                              const numericValue = e.target.value.replace(/\D/g, '');
                              setCpf_user(numericValue)
                            }}
                            value={formatCPF(cpf_user)}
                            maxLength={14}
                            required
                            disabled={loading}
                            style={{
                              borderColor: '#1e3c72',
                              borderWidth: '2px',
                              borderRadius: '15px',
                              fontSize: '1.1rem'
                            }}
                          />
                          <label htmlFor="floatingInput" style={{ color: '#1e3c72', fontWeight: '600' }}>
                            <i className="bi bi-card-text me-2"></i>CPF
                          </label>
                        </div>

                        <div className="form-floating position-relative mb-4">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control form-control-lg shadow-sm"
                            id="floatingPassword"
                            placeholder="Senha"
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            required
                            disabled={loading}
                            style={{
                              borderColor: '#1e3c72',
                              borderWidth: '2px',
                              borderRadius: '15px',
                              fontSize: '1.1rem',
                              paddingRight: '60px'
                            }}
                          />
                          <label htmlFor="floatingPassword" style={{ color: '#1e3c72', fontWeight: '600' }}>
                            <i className="bi bi-lock me-2"></i>Senha
                          </label>
                          <button
                            type="button"
                            onClick={togglePasswordVisibility}
                            className="btn position-absolute"
                            style={{
                              top: "50%",
                              right: "15px",
                              transform: "translateY(-50%)",
                              color: '#1e3c72',
                              zIndex: 5,
                              border: 'none',
                              background: 'transparent'
                            }}
                            disabled={loading}
                          >
                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                          </button>
                        </div>

                        <div className="d-grid gap-2 mb-4">
                          <button
                            type="submit"
                            className="btn btn-lg shadow-sm"
                            disabled={loading || !cpf_user || !password}
                            style={{
                              background: loading ? '#cccccc' : 'linear-gradient(135deg, #1e3c72 0%, #1a237e 100%)',
                              border: 'none',
                              color: 'white',
                              padding: '15px 20px',
                              borderRadius: '15px',
                              fontWeight: 'bold',
                              fontSize: '1.2rem',
                              boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                              transition: 'all 0.3s ease',
                              cursor: loading ? 'not-allowed' : 'pointer'
                            }}
                            onMouseOver={(e) => {
                              if (!loading && cpf_user && password) {
                                e.target.style.transform = 'translateY(-3px)';
                                e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.25)';
                              }
                            }}
                            onMouseOut={(e) => {
                              e.target.style.transform = 'translateY(0)';
                              e.target.style.boxShadow = '0 6px 20px rgba(0,0,0,0.15)';
                            }}
                          >
                            {loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Entrando...
                              </>
                            ) : (
                              <>
                                <i className="bi bi-box-arrow-in-right me-2"></i>
                                Entrar no Sistema
                              </>
                            )}
                          </button>
                        </div>

                        <div className="text-center">
                          <small className="text-muted">
                            <i className="bi bi-shield-check me-1"></i>
                            Acesso seguro e criptografado
                          </small>
                        </div>
                      </form>
                    </div>

                    {/* Footer do card */}
                    <div className="card-footer bg-transparent text-center d-flex flex-column align-items-center gap-1 py-3" style={{
                      borderTop: '1px solid rgba(30, 60, 114, 0.2)'
                    }}>
                      <button type="button" className="btn btn-link text-decoration-none fw-semibold p-0" onClick={handleOpenRecuperarSenha} style={{ color: '#1e3c72' }}>
                        <i className="bi bi-key-fill me-1"></i>
                        Esqueci minha senha
                      </button>
                      <button type="button" className="btn btn-link text-decoration-none fw-semibold p-0" onClick={handleModal} style={{ color: '#1e3c72' }}>
                        <i className="bi bi-building me-1"></i>
                        Solicitar cadastro de Empresa
                      </button>
                      <a
                        href={process.env.REACT_APP_PLAYLIST_TUTORIAL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-danger btn-sm text-decoration-none fw-semibold mt-2"
                        style={{
                          borderRadius: '20px',
                          padding: '8px 20px',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                        }}
                      >
                        <i className="bi bi-youtube me-1"></i>
                        Assistir Tutoriais do Sistema
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Rodapé da página */}
          <footer className="mt-auto position-relative" style={{
            background: 'linear-gradient(90deg, #1e3c72 0%, #1a237e 50%, #1e3c72 100%)',
            color: 'white',
            zIndex: 2,
            textAlign: 'center',
            padding: '20px 0',
            fontSize: '1rem',
            borderTop: '3px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 -4px 15px rgba(0,0,0,0.1)'
          }}>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <i className="bi bi-c-circle me-2"></i>
                  <strong>Copyright &copy; {new Date().getFullYear()} &mdash; Transtec World</strong>
                </div>
                <div className="col-12 mt-2">
                  <small className="opacity-75">
                    Sistema de Agendamento | Versão 2.0
                  </small>
                </div>
              </div>
            </div>
          </footer>
        </section>
      </body>

      {/* Banner de cookies */}
      {showBanner && (
        <div className="position-fixed bottom-0 start-0 end-0 p-3" style={{
          background: 'linear-gradient(90deg, #1e3c72 0%, #1a237e 100%)',
          color: 'white',
          marginBottom: '100px',
          boxShadow: '0 -4px 15px rgba(0,0,0,0.2)',
          zIndex: 1050
        }}>
          <div className="container d-flex justify-content-between align-items-center flex-wrap">
            <div className="me-3">
              <i className="bi bi-info-circle me-2"></i>
              <strong>Política de Cookies:</strong> Este site usa cookies para melhorar sua experiência.
              Ao continuar navegando, você aceita o uso de cookies.
            </div>
            <button
              onClick={acceptCookies}
              className="btn btn-light shadow-sm"
              style={{
                borderRadius: '20px',
                padding: '8px 25px',
                fontWeight: 'bold',
                transition: 'all 0.3s ease',
                border: '2px solid rgba(255, 255, 255, 0.2)'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
              }}
            >
              <i className="bi bi-check-circle me-1"></i>
              Aceitar Cookies
            </button>
          </div>
        </div>
      )}

      {/* Modal Cadastro de Usuário - Multi-Step */}
      <Modal
        show={modalOpen}
        onHide={handleCloseModal}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="text-white"
          style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #1a237e 100%)' }}>
          <Modal.Title className="fw-bold">
            <i className="bi bi-person-plus me-2"></i>
            {currentStep === 1 ? 'Solicitar Cadastro de Usuário' : 'Cadastro de Contatos'}
          </Modal.Title>
        </Modal.Header>
        
        <style>{`
          .modal-steps-container {
            overflow: hidden;
            position: relative;
          }
          
          .steps-wrapper {
            display: flex;
            transition: transform 0.3s ease-in-out;
            width: 200%;
          }
          
          .step-content {
            width: 50%;
            flex-shrink: 0;
          }
          
          .steps-wrapper.step-1 {
            transform: translateX(0);
          }
          
          .steps-wrapper.step-2 {
            transform: translateX(-50%);
          }
          
          .contato-card {
            transition: all 0.2s ease;
          }
          
          .contato-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          }
        `}</style>
        
        <Modal.Body className="p-4">
          <div className="modal-steps-container">
            <div className={`steps-wrapper step-${currentStep}`}>
              
              {/* ETAPA 1: Dados do Usuário */}
              <div className="step-content">
                <div className="alert alert-info mb-4">
                  <i className="bi bi-info-circle me-2"></i>
                  <strong>Etapa 1 de 2:</strong> Primeiro valide o CNPJ da sua empresa para prosseguir com o cadastro.
                </div>

                <form>
                  <div className="row">
                    <div className="col-12 mb-3">
                      <label htmlFor="cnpj" className="form-label fw-semibold">
                        <i className="bi bi-building me-1"></i>CNPJ da Empresa *
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control shadow-sm"
                          name="cnpj"
                          value={formState.cnpj}
                          onChange={handleChange}
                          id="cnpj"
                          required
                          maxLength={18}
                          placeholder="00.000.000/0000-00"
                          disabled={isValidatingCNPJ}
                        />
                        <button
                          type="button"
                          className="btn btn-success shadow-sm"
                          onClick={validateCNPJ}
                          disabled={(formState.cnpj.length < 18) || isValidatingCNPJ}
                        >
                          {isValidatingCNPJ ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Validando...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-search me-1"></i>
                              Validar
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="cpf" className="form-label fw-semibold">
                        <i className="bi bi-person-badge me-1"></i>CPF do Responsável *
                      </label>
                      <input
                        type="text"
                        className="form-control shadow-sm"
                        name="cpf"
                        value={formState.cpf}
                        onChange={handleChange}
                        id="cpf"
                        required
                        maxLength={14}
                        disabled={!cnpjValido}
                        placeholder="000.000.000-00"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="nome" className="form-label fw-semibold">
                        <i className="bi bi-person me-1"></i>Nome Completo *
                      </label>
                      <input
                        type="text"
                        className="form-control shadow-sm"
                        name="nome"
                        value={formState.nome}
                        onChange={handleChange}
                        id="nome"
                        required
                        disabled={!cnpjValido}
                        placeholder="NOME DO RESPONSÁVEL"
                        style={{ textTransform: 'uppercase' }}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label fw-semibold">
                      <i className="bi bi-envelope me-1"></i>E-mail Corporativo *
                    </label>
                    <input
                      type="email"
                      className={`form-control shadow-sm ${formState.email ? (isEmailPessoal ? 'is-invalid' : '') : ''}`}
                      name="email"
                      value={formState.email}
                      onChange={handleChange}
                      id="email"
                      required
                      disabled={!cnpjValido}
                      placeholder="email@empresa.com"
                    />
                    {isEmailPessoal && (
                      <div className="mt-2">
                        <div className="alert alert-warning py-2 px-3 mb-2 small">
                          <i className="bi bi-exclamation-triangle-fill me-1"></i>
                          <strong>Atenção:</strong> Para utilizar e-mail pessoal, é necessário preencher, assinar e anexar a
                          declaração de responsabilidade.
                          <div className="mt-2">
                            <a
                              href="/declaracao_transtec.zip"
                              download="declaracao_transtec.zip"
                              className="btn btn-sm btn-outline-primary"
                            >
                              <i className="bi bi-download me-1"></i>
                              Baixar Declaração
                            </a>
                          </div>
                        </div>
                        {/* Upload da declaração assinada */}
                        <div className="card border-warning">
                          <div className="card-body py-2 px-3">
                            <label className="form-label fw-semibold small mb-1">
                              <i className="bi bi-file-earmark-arrow-up me-1"></i>Anexar Declaração Assinada *
                            </label>
                            {!declaracaoFile ? (
                              <div>
                                <input
                                  type="file"
                                  className="form-control form-control-sm"
                                  accept=".pdf,.jpg,.jpeg,.png"
                                  onChange={handleDeclaracaoUpload}
                                  disabled={isUploadingDeclaracao || !cnpjValido}
                                />
                                <small className="text-muted">PDF, JPG ou PNG (máx. 5MB)</small>
                                {isUploadingDeclaracao && (
                                  <div className="mt-1">
                                    <span className="spinner-border spinner-border-sm text-primary me-1" role="status"></span>
                                    <small>Enviando...</small>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="d-flex align-items-center justify-content-between">
                                <span className="text-success small">
                                  <i className="bi bi-check-circle-fill me-1"></i>
                                  {declaracaoFile.name}
                                </span>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={handleRemoveDeclaracao}
                                >
                                  <i className="bi bi-trash me-1"></i>Remover
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="senha" className="form-label fw-semibold">
                        <i className="bi bi-lock me-1"></i>Senha *
                      </label>
                      <input
                        type="password"
                        className="form-control shadow-sm"
                        name="senha"
                        value={formState.senha}
                        onChange={handleChange}
                        id="senha"
                        required
                        disabled={!cnpjValido}
                        placeholder="Mínimo 6 caracteres"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="confirm" className="form-label fw-semibold">
                        <i className="bi bi-lock-fill me-1"></i>Confirmar Senha *
                      </label>
                      <input
                        type="password"
                        className={`form-control shadow-sm ${formState.confirm ? (formState.isPasswordMatch ? 'is-valid' : 'is-invalid') : ''}`}
                        name="confirm"
                        value={formState.confirm}
                        onChange={handleConfirmPassword}
                        id="confirm"
                        required
                        disabled={!cnpjValido}
                        placeholder="Repita a senha"
                      />
                      {formState.confirm && !formState.isPasswordMatch && (
                        <div className="invalid-feedback">
                          As senhas Não coincidem
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              </div>
              
              {/* ETAPA 2: Cadastro de Contatos */}
              <div className="step-content">
                <div className="alert alert-warning mb-4">
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  <strong>Etapa 2 de 2:</strong> Ao menos um contato de cada categoria deve ser informado (Financeiro, Operacional e Administrativo).
                </div>

                {/* seção Contatos Financeiros */}
                <div className="card border-success mb-3">
                  <div className="card-header bg-success text-white">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="flex-grow-1">
                        <h6 className="mb-1 fw-bold">
                          <i className="bi bi-cash-coin me-2"></i>
                          Contatos Financeiros ({getContatosPorTipo(1).length})
                        </h6>
                        <p className="mb-0 small opacity-75">
                          Para tratativas de cobranças, pagamentos e assuntos financeiros
                        </p>
                      </div>
                      {getContatosPorTipo(1).length === 0 && (
                        <span className="badge bg-danger">Obrigatório</span>
                      )}
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4 mb-2">
                        <input
                          type="text"
                          className="form-control form-control-sm shadow-sm"
                          name="nome"
                          value={contatoFormFinanceiro.nome}
                          onChange={(e) => handleContatoChange(e, 1)}
                          placeholder="Nome do contato"
                        />
                      </div>
                      <div className="col-md-3 mb-2">
                        <input
                          type="text"
                          className="form-control form-control-sm shadow-sm"
                          name="telefone"
                          value={contatoFormFinanceiro.telefone}
                          onChange={(e) => handleContatoChange(e, 1)}
                          maxLength="15"
                          placeholder="(11) 99999-9999"
                        />
                      </div>
                      <div className="col-md-4 mb-2">
                        <input
                          type="email"
                          className="form-control form-control-sm shadow-sm"
                          name="email"
                          value={contatoFormFinanceiro.email}
                          onChange={(e) => handleContatoChange(e, 1)}
                          placeholder="contato@empresa.com"
                        />
                      </div>
                      <div className="col-md-1 mb-2">
                        <button
                          type="button"
                          className="btn btn-success btn-sm w-100"
                          onClick={() => handleAddContato(1)}
                          disabled={!contatoFormFinanceiro.nome || !contatoFormFinanceiro.telefone || !contatoFormFinanceiro.email}
                          title="Adicionar contato financeiro"
                        >
                          <i className="bi bi-plus-circle"></i>
                        </button>
                      </div>
                    </div>
                    
                    {/* Lista de contatos financeiros */}
                    {getContatosPorTipo(1).length > 0 && (
                      <div className="mt-3">
                        <div className="list-group list-group-flush">
                          {contatosList.map((contato, index) => (
                            parseInt(contato.tipo_contato) === 1 && (
                              <div key={index} className="list-group-item px-2 py-2">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="flex-grow-1">
                                    <small className="fw-semibold d-block">{contato.nome}</small>
                                    <small className="text-muted">
                                      <i className="bi bi-telephone me-1"></i>{contato.telefone}
                                      <span className="mx-2">|</span>
                                      <i className="bi bi-envelope me-1"></i>{contato.email}
                                    </small>
                                  </div>
                                  <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleDeleteContato(index)}
                                    title="Remover"
                                  >
                                    <i className="bi bi-trash"></i>
                                  </button>
                                </div>
                              </div>
                            )
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* seção Contatos Operacionais */}
                <div className="card border-primary mb-3">
                  <div className="card-header bg-primary text-white">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="flex-grow-1">
                        <h6 className="mb-1 fw-bold">
                          <i className="bi bi-gear-fill me-2"></i>
                          Contatos Operacionais ({getContatosPorTipo(2).length})
                        </h6>
                        <p className="mb-0 small opacity-75">
                          Para comunicações sobre agendamentos, programação e operações
                        </p>
                      </div>
                      {getContatosPorTipo(2).length === 0 && (
                        <span className="badge bg-danger">Obrigatório</span>
                      )}
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4 mb-2">
                        <input
                          type="text"
                          className="form-control form-control-sm shadow-sm"
                          name="nome"
                          value={contatoFormOperacional.nome}
                          onChange={(e) => handleContatoChange(e, 2)}
                          placeholder="Nome do contato"
                        />
                      </div>
                      <div className="col-md-3 mb-2">
                        <input
                          type="text"
                          className="form-control form-control-sm shadow-sm"
                          name="telefone"
                          value={contatoFormOperacional.telefone}
                          onChange={(e) => handleContatoChange(e, 2)}
                          maxLength="15"
                          placeholder="(11) 99999-9999"
                        />
                      </div>
                      <div className="col-md-4 mb-2">
                        <input
                          type="email"
                          className="form-control form-control-sm shadow-sm"
                          name="email"
                          value={contatoFormOperacional.email}
                          onChange={(e) => handleContatoChange(e, 2)}
                          placeholder="contato@empresa.com"
                        />
                      </div>
                      <div className="col-md-1 mb-2">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm w-100"
                          onClick={() => handleAddContato(2)}
                          disabled={!contatoFormOperacional.nome || !contatoFormOperacional.telefone || !contatoFormOperacional.email}
                          title="Adicionar contato operacional"
                        >
                          <i className="bi bi-plus-circle"></i>
                        </button>
                      </div>
                    </div>
                    
                    {/* Lista de contatos operacionais */}
                    {getContatosPorTipo(2).length > 0 && (
                      <div className="mt-3">
                        <div className="list-group list-group-flush">
                          {contatosList.map((contato, index) => (
                            parseInt(contato.tipo_contato) === 2 && (
                              <div key={index} className="list-group-item px-2 py-2">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="flex-grow-1">
                                    <small className="fw-semibold d-block">{contato.nome}</small>
                                    <small className="text-muted">
                                      <i className="bi bi-telephone me-1"></i>{contato.telefone}
                                      <span className="mx-2">|</span>
                                      <i className="bi bi-envelope me-1"></i>{contato.email}
                                    </small>
                                  </div>
                                  <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleDeleteContato(index)}
                                    title="Remover"
                                  >
                                    <i className="bi bi-trash"></i>
                                  </button>
                                </div>
                              </div>
                            )
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* seção Contatos Administrativos */}
                <div className="card border-warning mb-3">
                  <div className="card-header bg-warning text-dark">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="flex-grow-1">
                        <h6 className="mb-1 fw-bold">
                          <i className="bi bi-shield-fill-check me-2"></i>
                          Contatos Administrativos ({getContatosPorTipo(3).length})
                        </h6>
                        <p className="mb-0 small opacity-75">
                          Para tratativas de emails específicos e assuntos sensíveis
                        </p>
                      </div>
                      {getContatosPorTipo(3).length === 0 && (
                        <span className="badge bg-danger">Obrigatório</span>
                      )}
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4 mb-2">
                        <input
                          type="text"
                          className="form-control form-control-sm shadow-sm"
                          name="nome"
                          value={contatoFormAdministrativo.nome}
                          onChange={(e) => handleContatoChange(e, 3)}
                          placeholder="Nome do contato"
                        />
                      </div>
                      <div className="col-md-3 mb-2">
                        <input
                          type="text"
                          className="form-control form-control-sm shadow-sm"
                          name="telefone"
                          value={contatoFormAdministrativo.telefone}
                          onChange={(e) => handleContatoChange(e, 3)}
                          maxLength="15"
                          placeholder="(11) 99999-9999"
                        />
                      </div>
                      <div className="col-md-4 mb-2">
                        <input
                          type="email"
                          className="form-control form-control-sm shadow-sm"
                          name="email"
                          value={contatoFormAdministrativo.email}
                          onChange={(e) => handleContatoChange(e, 3)}
                          placeholder="contato@empresa.com"
                        />
                      </div>
                      <div className="col-md-1 mb-2">
                        <button
                          type="button"
                          className="btn btn-warning btn-sm w-100"
                          onClick={() => handleAddContato(3)}
                          disabled={!contatoFormAdministrativo.nome || !contatoFormAdministrativo.telefone || !contatoFormAdministrativo.email}
                          title="Adicionar contato administrativo"
                        >
                          <i className="bi bi-plus-circle"></i>
                        </button>
                      </div>
                    </div>
                    
                    {/* Lista de contatos administrativos */}
                    {getContatosPorTipo(3).length > 0 && (
                      <div className="mt-3">
                        <div className="list-group list-group-flush">
                          {contatosList.map((contato, index) => (
                            parseInt(contato.tipo_contato) === 3 && (
                              <div key={index} className="list-group-item px-2 py-2">
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="flex-grow-1">
                                    <small className="fw-semibold d-block">{contato.nome}</small>
                                    <small className="text-muted">
                                      <i className="bi bi-telephone me-1"></i>{contato.telefone}
                                      <span className="mx-2">|</span>
                                      <i className="bi bi-envelope me-1"></i>{contato.email}
                                    </small>
                                  </div>
                                  <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleDeleteContato(index)}
                                    title="Remover"
                                  >
                                    <i className="bi bi-trash"></i>
                                  </button>
                                </div>
                              </div>
                            )
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Resumo Total */}
                <div className="alert alert-info mb-0">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>
                      <i className="bi bi-info-circle me-2"></i>
                      <strong>Total de contatos cadastrados:</strong> {contatosList.length}
                    </span>
                    {!hasContatoDeTodasCategorias() && (
                      <span className="badge bg-danger">
                        Pendente: {!getContatosPorTipo(1).length ? 'Financeiro ' : ''}
                        {!getContatosPorTipo(2).length ? 'Operacional ' : ''}
                        {!getContatosPorTipo(3).length ? 'Administrativo' : ''}
                      </span>
                    )}
                    {hasContatoDeTodasCategorias() && (
                      <span className="badge bg-success">
                        <i className="bi bi-check-circle me-1"></i>
                        Todas as categorias preenchidas
                      </span>
                    )}
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </Modal.Body>
        
        <Modal.Footer className="bg-light">
          {currentStep === 1 ? (
            <>
              <button
                type="button"
                className="btn btn-primary btn-lg shadow-sm px-4"
                onClick={handleSendUser}
                disabled={!formState.isPasswordMatch || !cnpjValido}
              >
                <i className="bi bi-arrow-right-circle me-2"></i>
                Confirmar Dados
              </button>
              <button type="button" className="btn btn-secondary btn-lg shadow-sm px-4" onClick={handleCloseModal}>
                <i className="bi bi-x-circle me-2"></i>
                Cancelar
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-outline-secondary btn-lg shadow-sm px-4"
                onClick={handleBackToStep1}
              >
                <i className="bi bi-arrow-left-circle me-2"></i>
                Voltar
              </button>
              <button
                type="button"
                className="btn btn-success btn-lg shadow-sm px-4"
                onClick={handleSendUser}
                disabled={!hasContatoDeTodasCategorias()}
                title={!hasContatoDeTodasCategorias() ? 'Adicione pelo menos um contato de cada categoria' : 'Enviar solicitação'}
              >
                <i className="bi bi-check-circle me-2"></i>
                Enviar Solicitação
              </button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      {/* Modal Cadastro de Entidade */}
      <Modal
        show={modalFormulario}
        onHide={handleCloseFormularioModal}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="text-white"
          style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #1a237e 100%)' }}>
          <Modal.Title className="fw-bold">
            <i className="bi bi-building me-2"></i>
            Novo Cadastro
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {/* Overlay quando está submetendo */}
          {isSubmittingEntity && (
            <div
              className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                zIndex: 1050,
                backdropFilter: 'blur(2px)'
              }}
            >
              <div className="text-center">
                <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
                <h5 className="text-primary">Cadastrando...</h5>
                <p className="text-muted">Por favor, aguarde.</p>
              </div>
            </div>
          )}

          <div className="alert alert-success mb-4">
            <i className="bi bi-check-circle me-2"></i>
            <strong>CNPJ encontrado!</strong> Complete as informações abaixo para finalizar o cadastro.
          </div>

          <form onSubmit={handleSubmitEntity}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="razao_social" className="form-label fw-semibold">
                  <i className="bi bi-building me-1"></i>Razão Social *
                </label>
                <input
                  type="text"
                  className="form-control shadow-sm"
                  id="razao_social"
                  name="razao_social"
                  value={formulario.razao_social}
                  onChange={handleFormularioChange}
                  required
                  disabled={isSubmittingEntity}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="fantasia" className="form-label fw-semibold">
                  <i className="bi bi-shop me-1"></i>Nome Fantasia
                </label>
                <input
                  type="text"
                  className="form-control shadow-sm"
                  id="fantasia"
                  name="fantasia"
                  value={formulario.fantasia}
                  onChange={handleFormularioChange}
                  disabled={isSubmittingEntity}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-8 mb-3">
                <label htmlFor="logradouro" className="form-label fw-semibold">
                  <i className="bi bi-geo-alt me-1"></i>Endereço Completo *
                </label>
                <input
                  type="text"
                  className="form-control shadow-sm"
                  id="logradouro"
                  name="logradouro"
                  value={formulario.logradouro}
                  onChange={handleFormularioChange}
                  required
                  disabled={isSubmittingEntity}
                />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="numero" className="form-label fw-semibold">
                  <i className="bi bi-hash me-1"></i>Número *
                </label>
                <input
                  type="text"
                  className="form-control shadow-sm"
                  id="numero"
                  name="numero"
                  value={formulario.numero}
                  onChange={handleFormularioChange}
                  required
                  disabled={isSubmittingEntity}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3">
                <label htmlFor="cep" className="form-label fw-semibold">
                  <i className="bi bi-mailbox me-1"></i>CEP *
                </label>
                <input
                  type="text"
                  className="form-control shadow-sm"
                  id="cep"
                  name="cep"
                  value={formulario.cep}
                  onChange={handleFormularioChange}
                  maxLength={9}
                  required
                  disabled={isSubmittingEntity}
                />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="cidade" className="form-label fw-semibold">
                  <i className="bi bi-geo me-1"></i>Cidade *
                </label>
                <input
                  type="text"
                  className="form-control shadow-sm"
                  id="cidade"
                  name="cidade"
                  value={formulario.cidade}
                  onChange={handleFormularioChange}
                  required
                  disabled={isSubmittingEntity}
                />
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="estado" className="form-label fw-semibold">
                  <i className="bi bi-map me-1"></i>Estado *
                </label>
                <input
                  type="text"
                  className="form-control shadow-sm"
                  id="estado"
                  name="estado"
                  value={formulario.estado}
                  onChange={handleFormularioChange}
                  maxLength="2"
                  required
                  disabled={isSubmittingEntity}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="bg-light">
          <button
            type="button"
            className="btn btn-success btn-lg shadow-sm px-4"
            onClick={handleSubmitEntity}
            disabled={!isFormularioCompleto() || isSubmittingEntity}
          >
            {isSubmittingEntity ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Cadastrando...
              </>
            ) : (
              <>
                <i className="bi bi-check-circle me-2"></i>
                Cadastrar
              </>
            )}
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-lg shadow-sm px-4"
            onClick={handleCloseFormularioModal}
            disabled={isSubmittingEntity}
          >
            <i className="bi bi-x-circle me-2"></i>
            Cancelar
          </button>
        </Modal.Footer>
      </Modal>

      {/* Modal Recuperação de Senha */}
      <Modal
        show={modalRecuperarSenha}
        onHide={handleCloseRecuperarSenha}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="text-white"
          style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #1a237e 100%)' }}>
          <Modal.Title className="fw-bold">
            <i className="bi bi-key-fill me-2"></i>
            Recuperar Senha
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="alert alert-info mb-4">
            <i className="bi bi-info-circle me-2"></i>
            Informe seu CPF. Caso esteja cadastrado, enviaremos um e-mail com instruções para redefinir sua senha.
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">
              <i className="bi bi-person-badge me-1"></i>CPF *
            </label>
            <input
              type="text"
              className="form-control shadow-sm"
              value={recuperarCpf}
              onChange={(e) => setRecuperarCpf(formatCPF(e.target.value))}
              placeholder="000.000.000-00"
              maxLength={14}
              disabled={isRecuperandoSenha}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="bg-light">
          <button
            type="button"
            className="btn btn-success btn-lg shadow-sm px-4"
            onClick={handleRecuperarSenha}
            disabled={!recuperarCpf || recuperarCpf.replace(/\D/g, '').length < 11 || isRecuperandoSenha}
          >
            {isRecuperandoSenha ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Enviando...
              </>
            ) : (
              <>
                <i className="bi bi-envelope me-2"></i>
                Enviar E-mail de Recuperação
              </>
            )}
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-lg shadow-sm px-4"
            onClick={handleCloseRecuperarSenha}
            disabled={isRecuperandoSenha}
          >
            <i className="bi bi-x-circle me-2"></i>
            Cancelar
          </button>
        </Modal.Footer>
      </Modal>

      {/* Modal - Cadastro Pendente com Email Pessoal */}
      <Modal show={modalPendente} onHide={handleClosePendenteModal} centered size="lg">
        <Modal.Header className="bg-warning text-dark">
          <Modal.Title>
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            Cadastro Pendente de Aprovação
          </Modal.Title>
          <button type="button" className="btn-close" onClick={handleClosePendenteModal}></button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="alert alert-info mb-3">
            <i className="bi bi-info-circle-fill me-2"></i>
            <strong>Olá{pendingUserData?.nome ? `, ${pendingUserData.nome}` : ''}!</strong>
            <p className="mb-0 mt-2">
              Seu cadastro está <strong>pendente de aprovação</strong> pelo administrador.
              Como seu registro utiliza um <strong>e-mail pessoal</strong>, é necessário o envio da
              <strong> declaração de responsabilidade</strong> assinada para que a aprovação possa ser realizada.
            </p>
          </div>

          <div className="card mb-3">
            <div className="card-body">
              <h6 className="card-title fw-bold">
                <i className="bi bi-download me-2"></i>1. Baixar a Declaração
              </h6>
              <p className="text-muted small mb-2">
                Faça o download do modelo, preencha e assine o documento.
              </p>
              <a
                href="/declaracao_transtec.zip"
                download="declaracao_transtec.zip"
                className="btn btn-outline-primary"
              >
                <i className="bi bi-file-earmark-zip me-1"></i>
                Baixar Declaração
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <h6 className="card-title fw-bold">
                <i className="bi bi-upload me-2"></i>2. Enviar a Declaração Assinada
              </h6>
              <p className="text-muted small mb-2">
                Após preencher e assinar, anexe o documento digitalizado abaixo.
              </p>
              {!declaracaoPendenteFile ? (
                <div>
                  <input
                    type="file"
                    className="form-control"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={handleDeclaracaoPendenteUpload}
                    disabled={isUploadingDeclaracaoPendente}
                  />
                  <small className="text-muted">PDF, JPG ou PNG (máx. 5MB)</small>
                  {isUploadingDeclaracaoPendente && (
                    <div className="mt-2">
                      <span className="spinner-border spinner-border-sm text-primary me-1" role="status"></span>
                      <small className="text-primary">Enviando arquivo...</small>
                    </div>
                  )}
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-between bg-light rounded p-2">
                  <span className="text-success small">
                    <i className="bi bi-check-circle-fill me-1"></i>
                    {declaracaoPendenteFile.name}
                  </span>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => { setDeclaracaoPendenteFile(null); setDeclaracaoPendenteS3Key(''); }}
                  >
                    <i className="bi bi-trash me-1"></i>Remover
                  </button>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="bg-light">
          <button
            type="button"
            className="btn btn-success btn-lg shadow-sm px-4"
            onClick={handleSubmitDeclaracaoPendente}
            disabled={!declaracaoPendenteS3Key || isSubmittingDeclaracaoPendente}
          >
            {isSubmittingDeclaracaoPendente ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Enviando...
              </>
            ) : (
              <>
                <i className="bi bi-send me-2"></i>
                Enviar Declaração
              </>
            )}
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-lg shadow-sm px-4"
            onClick={handleClosePendenteModal}
            disabled={isSubmittingDeclaracaoPendente}
          >
            <i className="bi bi-x-circle me-2"></i>
            Fechar
          </button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default Login;
